<template>
	<section class="header-margin"></section>
	<section class="m-banner m-banner__container">
		<div class="m-banner__mobile-crumb">
			<a class="m-banner__mobile-crumb-link" href="/urban/">Городская среда</a>
			<a class="m-banner__mobile-crumb-link" href="/urban/fund/"
				>Проекты фонда</a
			>
		</div>
		<div class="m-banner__image">
			<img
				:src="photo || '/static/v2/src/img/urban/fund/no-img.jpg'"
				:alt="city"
			/>
		</div>
		<div class="m-banner__content">
			<div class="m-banner__crumb">
				<a class="m-banner__crumb-link" href="/urban/">Городская среда</a>
				<a class="m-banner__crumb-link" href="/urban/fund/">Проекты фонда</a>
			</div>
			<div class="m-banner__title">{{ title }}</div>
			<div class="m-banner__type">
				<div class="m-banner__type-title">Тип проекта</div>
				<div class="m-banner__type-text" :class="type.code">
					{{ type.value }}
				</div>
			</div>
			<div class="m-banner__region">
				<div class="m-banner__region-title">Местоположение</div>
				<div class="m-banner__region-text">{{ region }}, {{ city }}</div>
			</div>
			<div class="m-banner__developer" v-if="developer">
				<div class="m-banner__developer-title">Разработчики</div>
				<div class="m-banner__developer-text">{{ developer }}</div>
			</div>
			<div class="m-banner__button-share">
				<button-share></button-share>
			</div>
		</div>
	</section>
</template>

<script>
import ButtonShare from './ButtonShare.vue'
import { mapState, mapGetters } from 'vuex'

export default {
	name: 'MainBanner',
	components: { ButtonShare },
	props: {},

	data() {
		return {}
	},
	watch: {
		// Здесь можно добавить наблюдатели
	},

	beforeCreate() {
		// Вызывается до создания экземпляра компонента
	},

	created() {
		// Вызывается после создания экземпляра компонента
	},

	beforeMount() {
		// Вызывается перед монтированием компонента
	},

	mounted() {
		// Вызывается после монтирования компонента
	},

	computed: {
		// Здесь можно добавить вычисляемые свойства
		...mapState({
			state: state => state,
			title: state => state.data.name,
			type: state => state.data.props.type,
			region: state => state.data.props.region.value,
			city: state => state.data.props.city.value,
			developer: state => state.data.props.developer.value,
			url: state => state.data.url,
			photo: state => state.data.props.photo.src,
		}),
	},
	methods: {
		// Здесь можно добавить методы
	},
}
</script>
